import { Preset } from '@primeuix/themes/types';

export const customerOverride = {
	components: {
		button: {
			extend: {
				width: '166px',
			},
		},
	},
} satisfies Preset;